var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOriginHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#109B32",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7932 12.3261C23.3865 12.8033 23.7348 13.5212 23.7424 14.2826L23.7352 20.9275C23.7352 22.7325 22.272 24.1957 20.4671 24.1957H19.0178C18.1442 24.1957 17.4348 23.4896 17.4308 22.6159V19.6159C17.4308 19.3838 17.2427 19.1957 17.0105 19.1957H14.8366C14.7239 19.1956 14.6159 19.2409 14.5368 19.3213C14.4578 19.4017 14.4144 19.5105 14.4163 19.6232V20.7681C14.4163 21.1283 14.1244 21.4203 13.7642 21.4203C13.404 21.4203 13.112 21.1283 13.112 20.7681V19.6232C13.112 19.1639 13.2945 18.7234 13.6193 18.3986C13.944 18.0738 14.3846 17.8913 14.8439 17.8913H17.0178C17.9715 17.8953 18.7424 18.6695 18.7424 19.6232V22.6159C18.7424 22.768 18.8657 22.8913 19.0178 22.8913H20.5033C21.5839 22.8913 22.4598 22.0153 22.4598 20.9348V14.2971C22.4545 13.9294 22.2842 13.5835 21.9961 13.3551L16.9888 9.36232C16.3574 8.84249 15.4463 8.84249 14.8149 9.36232L13.2062 10.5652C12.908 10.7793 12.4928 10.7112 12.2787 10.413C12.0645 10.1149 12.1327 9.69962 12.4308 9.48551L14.0178 8.33333C15.1181 7.44887 16.6856 7.44887 17.7859 8.33333L22.7932 12.3261ZM11.3511 22.8841H14.6845V22.8985C15.0446 22.8985 15.3366 23.1905 15.3366 23.5507C15.3366 23.9109 15.0446 24.2029 14.6845 24.2029H11.3511C9.54785 24.1989 8.08699 22.7381 8.08301 20.9348V14.2971C8.09454 13.5301 8.45457 12.81 9.06127 12.3406L9.66272 11.8913C9.94594 11.7578 10.2841 11.8444 10.4682 12.0976C10.6524 12.3509 10.6306 12.6992 10.4163 12.9275L9.82938 13.3623C9.55127 13.5934 9.38948 13.9355 9.38736 14.2971V20.9275C9.39529 22.0076 10.271 22.8801 11.3511 22.8841Z",
    fill: "#004800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOriginHouse);
export default __webpack_public_path__ + "static/media/origin-house.053b5f49db43d3266afd1d5ec2054f07.svg";
export { ForwardRef as ReactComponent };